import React from 'react';
import { useSelector } from 'react-redux';
import Tooltip from '../../../../../ui/tooltip/Tooltip';
import classes from './ParticipantsCell.module.css';

const ParticipantsCell = ({ value, row }) => {

  const { texts } = useSelector(state => state.translate);

  const participantsCount = value
  const studentCount = row?.studentCount;

  return (
    <Tooltip text={`${participantsCount} ${texts.participantsTooltipParticipating} ${studentCount} ${texts.participantsTooltipTotal}`} showTooltip={true}>
      <div className={classes.participantsCell}>
        {/* <Icon name={iconsList.people} size={16} className={classes.participantsIcon} /> */}
        <span className={classes.participantsText}>{`${participantsCount}/${studentCount}`}</span>
      </div>
    </Tooltip>
  );
};

export default ParticipantsCell;
